import { formatNumber } from '@/utils/number';

export function NumericCell({ value }: { value: number | null | undefined }) {
  return <span className="tabular-nums">{formatNumber(value)}</span>;
}
